import { BLANK_VALUE } from 'consts/ui'

export const formatBlankLabel = (label: string, value?: string) =>
  (value ?? label) === BLANK_VALUE ? 'Not specified' : label
